module.exports = __webpack_public_path__ + "static/img/dataLeakInstallForMac_pic12.5dfa464.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/dataLeakInstallForMac/dataLeakInstallForMac_pic12.png
// module id = 477
// module chunks = 1